import React, {Component} from 'react';
import {
  BrowserRouter as Router,
  Route,
  NavLink,
  Link
} from "react-router-dom";

import Welcome from "./welcome";


import Report_Sorted_Donations from "./reportService/sorted_donations_report/report_sorted_donations";
import Credit_Card_Report from "./reportService/creditcard_report/report_credit_card";
import Cheque_Report from "./reportService/cheque_report/report_cheque";
import Funds_Transfer_Report from "./reportService/funds_transfer_report/funds_transfer_report";
import Ministry_Donations_Report from "./reportService/ministry_donations_report/generate_reports";
import Donations_By_Payment_Type_Report from "./reportService/donation_by_payment_type_report/donations_by_paymenttype_report";

// Control Panel
import Funds_Budget_Plan_Mgm from "./reportService/controlPanel/fund_budget_plan_mgm/fund_budget_plan_mgm.js";
import Bank_Account_Mgm from "./reportService/controlPanel/bank_account_mgm/bank_account_mgm.js";
import Donation_Groups_Mgm from "./reportService/sorted_donations_report/donation_groups_mgm.js";
import Ministry_Contact_Mgm from "./reportService/ministry_donations_report/ministry_contact_mgm.js";
import Office_Desigs_Mgm from "./reportService/controlPanel/office_desigs_mgm.js";
import UpdateInfo from './reportService/controlPanel/updateInfo.js';

import Pending_Funds_Transfer_Report from "./reportService/funds_transfer_report/pending_funds_transfer_report.js";
import Approved_Funds_Transfer_Report from "./reportService/funds_transfer_report/approved_funds_transfer_report.js"
import Pending_Ministry_Donations_Report from "./reportService/ministry_donations_report/approve_reports.js";
import Approved_Ministry_Donations_Report from "./reportService/ministry_donations_report/email_out_reports.js";


import './css/index.css';
import './css/admin_reports.css';
import './css/primereact.css'
import 'primereact/resources/themes/saga-blue/theme.css'
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};


class Home extends Component {

  constructor(props){
    super(props);
    this.state = {
      super_tab:'',
      switch_tab:'',
      validUser: false,
      name:'',
      employee: ''
    }

  }


  componentDidMount() {
    this.renderNavBar();
  }

  handlelogout = _ => {
    sessionStorage.setItem('int', 'logout');
  }


  renderNavBar = _ => {

    var staff_access = sessionStorage.getItem('staff');
    var admin_access = sessionStorage.getItem('admin');
    var super_access = sessionStorage.getItem('super');
    var employee = sessionStorage.getItem('id_e');
    var staff = sessionStorage.getItem('id_s');
    var name = sessionStorage.getItem('name');

    // var staff_access = false;
    // var admin_access = true;
    // var super_access = true;
    // var employee = 3;
    // var staff = null;
    // var name = 'shishan';

    this.setState({name: name});
    this.setState({staff: staff});
    this.setState({employee: employee})


    if (admin_access){
      this.setState({validUser: true});
    }
    if (super_access){
      var super_tab = (
        <li className="dropdown">
            <NavLink to="/{staff}/admin/manage_staff" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">MANAGE<span className="caret"></span></NavLink>
            <ul className="dropdown-menu" role="menu">
              <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/manage_staff">Manage Staff</NavLink></li>
              <li className="divider"></li>
              <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/params">Manage Charges Rates</NavLink></li>
            </ul>
        </li>)

      this.setState({super_tab: super_tab});
    }

    if(staff_access){
              // <Link to={{ pathname:`/${employee}/staff` }} onClick={ () => this.props.changePortal('staff')}>
      var link = '/' + employee + '/staff';
      var switch_tab = (
        <li className="">

          <Link to={link} onClick={ () => this.props.changePortal('staff').bind(this)}>
            SWITCH TO STAFF<span className="sr-only"></span>
          </Link>
        </li>)
      this.setState({switch_tab: switch_tab});
    }

  }

  render(){

    // let {super_tab} = this.state;
    let {validUser} = this.state;
    let {name} = this.state;
    var {employee} = this.state;
    var mobile = isMobileDevice();

    // var url = window.location.href;
    // var parts = url.split('/')
    // var lastSegment = parts.pop() || parts.pop(); 
    // console.log(lastSegment);
    // console.log(url)
    console.log(validUser, employee, name)


    if(validUser){
      return (
        <div className = "Admin">
          <Router>
            <div>
              <nav className="navbar navbar-default">
                <div className="container-fluid">
                  <div className="navbar-header">
                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                      <span className="sr-only">Toggle navigation</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                    <a className="navbar-brand" href="/"><img id="logo" src="/img/logo.png" alt="Navlogo"/></a>
                  </div>

                  <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul className="nav navbar-nav">

                      <li className="dropdown">
                        <button className="dropdown-button dropdown-toggle" data-toggle="dropdown"  aria-expanded="false">Generate Reports <span className="caret"></span></button>
                        <ul className="dropdown-menu" role="menu">
                          {/* <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/employee_yearly">Yearly Reserves Per Employee Report</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/total_yearly">Total Yearly Reserves Report</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/monthly">Monthly Payroll Detail Report</NavLink></li>
                          <li className="divider"></li> */}
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to={`/${employee}/admin/report/sorted_donations`}>Sorted Donations Report</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/credit_card_charges">Credit Card Charges Report</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/cheque_charges">Cheque Charges Report</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/funds_transfer">Funds Transfer Report</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/ministry_donations">Ministry Donations Report</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/payment_type">Donations By Payment Type Report</NavLink></li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <button className="dropdown-button dropdown-toggle" data-toggle="dropdown"  aria-expanded="false">Control Panel<span className="caret"></span></button>
                        <ul className="dropdown-menu" role="menu">
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/controlpanel/budgetplan">Fund-raising Projects</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/controlpanel/bankaccount">Bank Account</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/controlpanel/officedesigs">Designations Directed to Office</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/controlpanel/donationgroup">Donation Groups</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/controlpanel/ministrycontact">Ministry Contacts</NavLink></li>
                          <li className="divider"></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/controlpanel/updateInfo">Modify Overseas Donor & Charges Rate</NavLink></li>
                        </ul>
                      </li>


                      <li className="dropdown">
                        <button className="dropdown-button dropdown-toggle" data-toggle="dropdown"  aria-expanded="false">Process Reports<span className="caret"></span></button>
                        <ul className="dropdown-menu" role="menu">
                          {/*}<li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/admin/report/employee_yearly">Yearly Reserves Per Employee Report</NavLink></li>
                          <li className="divider"></li>*/}
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/fundstransferreports/pending">Pending Funds Transfer Report</NavLink></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/fundstransferreports/approved">Approved Funds Transfer Report</NavLink></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/ministryreports/pending">Pending Ministry Donations Report</NavLink></li>
                          <li data-toggle="collapse" data-target=".navbar-collapse.show"><NavLink to="/{staff}/ministryreports/approved">Approved Ministry Donations Report</NavLink></li>

                        </ul>
                      </li>

                    </ul>

                    <ul className="nav navbar-nav navbar-right">

                      <li>
                        {/*}<a href="/.auth/logout" onClick={this.deleteSession}>*/}
                        <a href='/logout' onClick = {() => this.handlelogout()}>
                          LOG OUT<i className="material-icons" style={{fill:'white'}}>exit_to_app</i>
                        </a>
                      </li>*/

                      <li>
                        { mobile ?
                          <a href="/{staff}/adminmobile/home"> Switch to Mobile Device Version
                          </a> : <span>{null}</span>
                        }
                      </li>

                    </ul>

                  </div>
                </div>
              </nav>

              <div className="content container">

                <Route path="/:staff/home" component={Welcome}/>
          
                <Route path="/:staff/admin/report/sorted_donations" component={Report_Sorted_Donations}/>
                <Route path="/:staff/admin/report/credit_card_charges" component={Credit_Card_Report}/>
                <Route path="/:staff/admin/report/cheque_charges" component={Cheque_Report}/>
                <Route path="/:staff/admin/report/funds_transfer" component={Funds_Transfer_Report}/>
                <Route path="/:staff/admin/report/ministry_donations" component={Ministry_Donations_Report}/>
                <Route path="/:staff/admin/report/payment_type" component={Donations_By_Payment_Type_Report}/>

                <Route path="/:staff/controlpanel/budgetplan" component={Funds_Budget_Plan_Mgm}/>
                <Route path="/:staff/controlpanel/bankaccount" component={Bank_Account_Mgm}/>
                <Route path="/:staff/controlpanel/donationgroup" component={Donation_Groups_Mgm}/>
                <Route path="/:staff/controlpanel/ministrycontact" component={Ministry_Contact_Mgm}/>
                <Route path="/:staff/controlpanel/officedesigs" component={Office_Desigs_Mgm}/>
                <Route path="/:staff/controlpanel/updateInfo" component={UpdateInfo}/>
                
                <Route path="/:staff/fundstransferreports/pending" component={Pending_Funds_Transfer_Report}/>
                <Route path="/:staff/fundstransferreports/approved" component={Approved_Funds_Transfer_Report}/>
                <Route path="/:staff/ministryreports/pending" component={Pending_Ministry_Donations_Report}/>
                <Route path="/:staff/ministryreports/approved" component={Approved_Ministry_Donations_Report}/>

              </div>

            </div>
          </Router>
        </div>
      );
    }

    else{
      return(
        <div className = "Admin">
          <Router>
            <div>
            <nav className="navbar navbar-default">
              <div className="container-fluid">
                <div className="navbar-header">
                  <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                  <a className="navbar-brand" href="/"><img id="logo" src="/img/logo.png" alt="Navlogo"/></a>
                </div>
              </div>
            </nav>

            <div className="content container">
              <h1 className="staff_greeting">Hi {name}! </h1>
              <h1>Sorry that you do not have access to this page!</h1>
              <h1>If this is a mistake, please contact it@navigators.org.sg</h1>
            </div>

            </div>
          </Router>
        </div>
      )
    }


  }
}


export default Home;
